import { Outlet, Link } from "react-router-dom"
import { Fragment } from "react"
import { ReactComponent as CrownLogo } from '../../assets/crown.svg'

import './navigation.style.scss'
const Navbar = () => {
    return (
        <Fragment >
            <div className="navigation">
                <Link className="logo-container" to='/Uncrown-city-ecomerce'>
                    <CrownLogo className="logo" title="Uncrown City Clothing" />
                    
                </Link>
                <div className="nav-links-container">
                    <Link className="nav-link" to='uncrown-city-ecomerce/shop'>Shop </Link>
                    <Link className="nav-link" to='uncrown-city-ecomerce/SignIn'>Sign In </Link>
                </div>
            </div>
        <Outlet />
        </Fragment>
    )
}

export default Navbar